import { Button } from 'component/Button'
import { Qr } from 'component/Qr'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { BuyButtons } from 'page/InferenceScreen/buy/BuyButtons'
import { LookyButton } from 'page/InferenceScreen/buy/LookyButton'
import { imageQrModal, ImageQrModalStore } from 'page/InferenceScreen/ImageQrModal/ImageQrModalStore'
import { InferenceSizes } from 'page/InferenceScreen/InferenceSizes'
import { renderItemTitles } from 'page/InferenceScreen/ItemTitle'
import { renderProductInfo } from 'page/InferenceScreen/ProductInfo'
import { Fragment } from 'react'
import { FailedBottom } from 'shared/inference/FailedBottom'
import { ProcessingBottom } from 'shared/inference/ProcessingBottom'
import { InferenceStore } from 'store/inference/InferenceStore'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { buildViewLink } from 'type/Inference'

type Props = {
  inference: InferenceStore
}

export const BottomPanel = observer(({ inference }: Props) => {
  const { error, complete } = inference
  if (error) return <FailedBottom />
  if (!complete) return <ProcessingBottom inference={inference} />
  return <Complete inference={inference} />
})

const Complete = observer(({ inference }: Props) => {
  const { height, tablet } = store.frame
  const { stand } = opt
  const info = renderProductInfo(inference)
  const { inference_id, items, links } = inference
  const combo = items.length > 1
  const show_buy = (!combo && opt.buy_single) || (combo && opt.buy_combo) || store.customBuy
  const shop = !stand && !info && (!!links || store.customBuy) && show_buy
  const titles = info ? null : renderItemTitles(items)
  const show_tiles = !!titles?.length
  const some = stand || info || shop || show_tiles
  const link = buildViewLink(inference_id)
  const size = height < 800 ? 160 : height < 1200 ? 240 : 320

  const onShare = useLatestCallback(() => {
    imageQrModal.open(new ImageQrModalStore(inference))
  })

  if (!some) return null

  return (
    <Vertical gap={12} pad={[0, 16]}>
      {info}
      {show_tiles && (
        <Space gap={12} top columns>
          {titles.map((title, i) => (
            <Fragment key={i}>{title}</Fragment>
          ))}
        </Space>
      )}
      {opt.foo && <LookyButton inference={inference} />}
      {shop && !opt.foo && <BuyButtons inference={inference} />}
      <InferenceSizes inference={inference} />
      {stand && tablet && (
        <Button gap={16} large primary action={onShare}>
          <Icon size={20} name="qr_code" />
          <Typo>
            {opt.f4 ? i18n('ShareOrBuy') : i18n('Share')}
          </Typo>
        </Button>
      )}
      {stand && !tablet && (
        <Vertical>
          <Space wide center>
            <Qr link={link} size={size} pad={16} />
          </Space>
          <Typo size={20} center>
            {opt.f4 ? i18n('PointYourCameraToShareTheResultOrBuyItem') : i18n('PointYourCameraToShareTheResult')}
          </Typo>
        </Vertical>
      )}
    </Vertical>
  )
})
